import React from "react";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./App.css";
import loader from "./images/loader.gif";
import Main from "./Main";

export const Loading = () => (
  <div className="d-flex cover-loader justify-content-center align-items-center">
    <img className="small-loader" src={loader} alt="loading..." />
  </div>
);

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      appReady: false,
    };

    this.renderContent = this.renderContent.bind(this);
  }

  componentDidMount() {
    this.setState({
      appReady: true,
    });
  }

  renderContent() {
    if (this.state.appReady) {
      return <Main />;
    } else {
      return (
        <div className="full-page d-flex align-items-center justify-content-center">
          <Loading />
        </div>
      );
    }
  }

  render() {
    return this.renderContent();
  }
}

export default App;
